import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { obtenerDemorasEnVolcadoras } from '../../actions/EstadisticasVolcadorasActions'
import DemoraEnVolcadorasView from '../../components/estadisticasVolcadoras/DemoraEnVolcadorasView'

function DemorasVolcadoras (props) {
  const { filtroInicial = null, fecha = null, obtenerDemorasEnVolcadoras } = props

  useEffect(() => {
    const fechaD = fecha || new Date()
    const fechaH = fecha || new Date()
    obtenerDemorasEnVolcadoras(fechaD, fechaH, filtroInicial)
  }, [obtenerDemorasEnVolcadoras, filtroInicial, fecha])

  const actualizarfechas = (fechaD, fechaH) => {
    obtenerDemorasEnVolcadoras(fechaD, fechaH)
  }

  return (
    <>
      {!fecha &&
        <Col md={4} style={{ margin: '12px auto' }}>
          <DatePicker
            style={{ width: '95%' }}
            disabledFuture
            selectRange
            locale='es'
            value={fecha || new Date()}
            onDateChange={actualizarfechas}
            titulo='Seleccione las fechas'
          />
        </Col>
      }

      <div style={{ margin: '2% 0' }}>
        <DemoraEnVolcadorasView />
      </div>
    </>
  )
}

const mapActionsToProps = {
  obtenerDemorasEnVolcadoras
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DemorasVolcadoras)
